export const getTrailingDigits = (
  input: string,
  numberOfDigits: number = 4,
): string => {
  if (!Number.isInteger(numberOfDigits) || numberOfDigits < 0) {
    throw new Error('numberOfDigits must be a positive integer');
  }

  if (numberOfDigits === 0) {
    return '';
  }

  const digitsOnly = input.replace(/\D/g, '');
  if (digitsOnly.length === 0) {
    return '';
  }

  const validNumberOfDigits = Math.min(numberOfDigits, digitsOnly.length);

  return digitsOnly.slice(-validNumberOfDigits);
};
